import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/site/PageHeader";
import { supabase } from "@/integrations/supabase/client";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/lp/$slug")({
  head: ({ params }) => ({
    meta: [
      { title: `${params.slug} — Glow Long Golf` },
      { property: "og:title", content: `${params.slug} — Glow Long Golf` },
      { property: "og:url", content: `https://glowlonggolf.com/lp/${params.slug}` },
      { property: "og:image", content: SHARE_IMAGES.teeOff },
      { name: "twitter:image", content: SHARE_IMAGES.teeOff },
    ],
    links: [{ rel: "canonical", href: `https://glowlonggolf.com/lp/${params.slug}` }],
  }),

  component: LandingPage,
});

function LandingPage() {
  const { slug } = Route.useParams();
  const { data, isLoading } = useQuery({
    queryKey: ["lp", slug],
    queryFn: async () => {
      const { data } = await supabase.from("landing_pages").select("*").eq("slug", slug).eq("is_active", true).maybeSingle();
      return data;
    },
  });
  if (isLoading) return <div className="mx-auto max-w-3xl px-4 py-20 text-muted-foreground">Loading…</div>;
  if (!data) throw notFound();
  const lp: any = data;
  return (
    <>
      <PageHeader eyebrow={lp.template} title={lp.headline} lead={lp.subheadline ?? undefined} />
      <section className="mx-auto max-w-2xl px-4 pb-16 text-center sm:px-6 lg:px-8">
        {lp.offer_text && <p className="mb-6 text-primary font-semibold">{lp.offer_text}</p>}
        <Link to={lp.cta_href as any} className="inline-flex rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90">
          {lp.cta_label}
        </Link>
      </section>
    </>
  );
}
